import Cookies from 'universal-cookie';
const cookies = new Cookies();

class BaseCookieHandler {
  path = '/';
  cookieName = '';
  constructor(cookieName) {
    this.cookieName = cookieName;
  }

  set(value) {
    cookies.set(this.cookieName, value, { path: '/' });
  }
  get() {
    return cookies.get(this.cookieName);
  }
}

export class StateCookie extends BaseCookieHandler {
  keys = {
    teamId: 'teamId',
  };

  constructor() {
    super('stateCookie');
  }

  getLastTeamId(): string | null {
    const value = this.get();
    const teamId = value ? value[this.keys.teamId] : null;
    console.log('🍪 COOKIE: getLastTeamId', { value, teamId });
    return teamId;
  }
  setLastTeamId(teamId?: string) {
    if (!teamId) {
      console.log('🍪 COOKIE: setLastTeamId called with empty teamId, skipping');
      return;
    }
    let value = this.get();
    if (!value) value = {};
    console.log('🍪 COOKIE: setLastTeamId setting teamId:', { oldValue: value, teamId });
    value[this.keys.teamId] = teamId;
    this.set(value);
    console.log('🍪 COOKIE: setLastTeamId completed');
  }
}
